import {
  IElementCategory,
  ElementCategoryID,
} from '../../../models/element-categories.model';
import {
  DEFAULT_AREAL_DENSITY_PROPERTIES,
  DEFAULT_QUANTITY_PROPERTIES,
} from '../../../models/element-quantities.model';
import { metalProperties } from './metal-properties';
import {
  getElementPropertySelectionByValue,
  getValueFromConditionalNodes,
} from '../../../helpers/conditional-nodes.helpers';
import { metalProductIds } from './metal-product-ids';
import { ProductID } from '../../../models/product.model';

export const metal: IElementCategory = {
  id: ElementCategoryID.Metal,
  defaultSelectedQuantity: 'mass',
  name: 'Metal',
  color: '#96D5DD',

  properties: metalProperties,

  getQuantityProperties: () => ({
    ...DEFAULT_QUANTITY_PROPERTIES,
    ...DEFAULT_AREAL_DENSITY_PROPERTIES,
  }),
  // `throwIfNotFound: false` + `undefined` passthrough: during proposal-scoped
  // edits the element can be in a transient inconsistent state (e.g.
  // material=Aluminum while form=Wire is still in `form.count` from a prior
  // Copper-only action). The conditional tree has no leaf for those combos;
  // throwing would crash the whole enrich pass. `undefined` tells
  // `applyCategoryChildElements` to skip enrichment and keep existing
  // generated children intact until the element reaches a valid state again
  // (vs `[]` which would strip them).
  getChildElements: (element) =>
    getValueFromConditionalNodes(element, [metalProductIds], false),
  getElementPropertySelectionByProductId: (productId: ProductID) =>
    getElementPropertySelectionByValue(productId, metalProductIds),
};
